import $ from "jquery";
import videojs from "video.js";
import compile from "@bd-utils/handlerbars-helper";
import copyTextToClipboard from "@bd-utils/copyTextToClipboard";
import fb from "@bd-core/firebase";
import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import GameLogic from "@bd-core/game-logic";
import { dispatch, getState, subscribe } from "@bd-stores/store";
import { getPlayers, getUserFromId } from "@bd-stores/game-progress";
import { setHasSeenGameIntro } from "@bd-core/firebase-actions";
import { isTestMode } from "@bd-utils/test-mode";
import { setPlayingOnline, setRegion } from "@bd-stores/page-waiting-room";

export const WaitingRoom = () => {
    const isWaitingRoom = $("#page-waitingroom").length > 0;

    if (!isWaitingRoom) return false;

    const elms = {
        pageWaitingRoom: "#page-waitingroom",
        waitingroom: ".waitingroom",
        setupTeamName: ".setupteamname",
        waitingroomSubtitle: ".waitingroom__subtitle",
        everyoneReady: ".waitingroom__title .allready",
        waitingEveryone: ".waitingroom__title .stillwaiting",
        readyBtn: ".js-ready-btn",
        cancelBtn: ".js-cancel-btn",
        member: ".member",
        memberEmailValue: ".member-email span",
        startBtn: ".js-start-game",
        cancelStart: ".js-cancel-start",
        proceedGame: ".js-proceed-game",
        countdownSecond: ".waitingroom-countdown-timer .second .column.animate",
        countdownSecondNum:
            ".waitingroom-countdown-timer .second .column.animate .num",
        introVideo: "#intro-video",

        playerList: ".js-player-list",
        playerItem: ".js-player-item",
        deletePlayerBtn: ".js-player-item-delete",
        teamName: ".js-teamname",
        gameInfoLeave: ".js-leave-team",

        teamId: ".teamId",
        teamIdCopy: ".js-copy-team-id",
        teamIdValue: ".js-team-id-value",

        gameInfo: ".gameInfo",
        gameInfoBtn: ".gameInfo__btn",
        leaderPopup: ".js-leader-popup",

        isPlayingOnlineToggle: ".js-is-playing-online",
        regionDropdown: ".js-region",
        regionToggler: ".js-region-label",
        regionSelector: ".js-region-selector",
        regionSelectorButton: ".js-region-button",

        // setup profile elements
        profileWrapper: ".profileBox",
        inputNickname: ".js-nickname",

        // teamname generator
        categoryList: ".js-category-list",
        categoryBtn: ".js-category",
        randomizerBtn: ".js-randomizer",
        removeBtn: ".js-remove-word",
        firstWordTxt: ".js-first-word",
        secondWordTxt: ".js-second-word",

        skipVideoBtn: ".js-skip-video",
    };

    let teamNameTemp = "";
    let isPlayingOnlineTemp = 1;
    let regionTemp = "Global";

    /**
     * Get relative path of a url without the site / hostname
     *
     * @param {string} url
     */
    const getRelativeUrl = (url) => {
        const site = CONFIG.siteURL;
        return url.replace(site, "");
    };

    /**
     * Check is given url provided from avatar options or is it custom upload.
     * false mean it's provided avatar, true means it's custom upload
     *
     * @param {string} url file url to check
     */
    const checkIsCustomAvatar = (url) => {
        const options = CONFIG.avatarOptions;

        if (options.length < 1) return false;

        const getUrl = (k) => getRelativeUrl(options[k]);
        const provided = Object.keys(options).map((k) => getUrl(k));
        return !provided.includes(url);
    };

    const getIsCompleteProfile = () => {
        const user = getUserFromId(CONFIG.user.id);
        const isFilledName = $(elms.inputNickname).val() !== "";

        const players = getPlayers();
        const myData = players.find((p) => p.userId === user?.userId);
        const hasSetupProfile = Boolean(myData?.hasSetupProfile);
        const isCompleteProfile = isFilledName && hasSetupProfile;

        return isCompleteProfile;
    };

    const render = (rawData = {}) => {
        const user = getUserFromId(CONFIG.user.id);
        const isUploadAvatar = checkIsCustomAvatar(user.avatarURL);
        const isCompleteProfile = getIsCompleteProfile();

        const avatarOptions = Object.keys(CONFIG.avatarOptions).map((k) => ({
            value: k,
            url: CONFIG.avatarOptions[k],
            isSelected:
                isCompleteProfile && isUploadAvatar
                    ? false
                    : getRelativeUrl(CONFIG.avatarOptions[k]) ===
                      user.avatarURL,
        }));

        const data = {
            ...rawData,
            teamCode: CONFIG.firebase.team_code.toUpperCase(),
            isUploadAvatar,
            avatarOptions,
            user: getUserFromId(CONFIG.user.id),
        };

        const template = $("#page-waitingroom-template").html();
        const html = compile(template, data);
        $("#page-waitingroom").html(html);
    };

    const renderAfterInitialized = () => {
        let hasRendered = false;

        subscribe(() => {
            const store = getState();
            if (!store.userProgress.isFirebaseInitialized) return;
            if (store.gameProgress.players.length < 1) return;
            if (hasRendered) return;
            hasRendered = true;

            render(getState().pageWaitingRoom);
        });
    };

    renderAfterInitialized();

    const updateUI = () => {
        const isCompleteProfile = getIsCompleteProfile();
        $(elms.profileWrapper).toggleClass("is-profile-set", isCompleteProfile);
        $(elms.pageWaitingRoom).toggleClass(
            "is-profile-set",
            isCompleteProfile,
        );
    };

    subscribe(() => {
        updateUI();
    });

    //----------------------------------------------------------------------- Initialize Firebase
    try {
        fb.initializeGame().then();
    } catch (e) {
        console.error(e);
    }
    //----------------------------------------------------------------------- End Initialize Firebase

    // ------------------------------------------------------------------- WAITING ROOM

    let isLoading = false;
    let isReady = false;

    const onPlayerStateChange = (e, eData) => {
        if (!eData || !eData.data) return;

        //handle ready state
        isReady = eData.data.ready;
        $(elms.gameInfo).toggleClass("is-ready", isReady);
        // const newText = isReady ? textCancel : textReady;
        const newText = isReady ? "I Am Ready !" : "Ready?";

        $(elms.readyBtn).find("span").text(newText);
        // console.log(newText)
        $(elms.readyBtn).toggleClass("is-ready", isReady);
        $(elms.cancelBtn).toggleClass("is-ready", isReady);
        $(".waitingroom__action-title").toggleClass("hide-title", isReady);
    };

    bdjs.listen("bd__playerStateChanged", onPlayerStateChange);

    //On players changed
    //-------------------------------------------------------------------------
    let isLeaving = false;
    let kickedPopup = false;
    const updatePlayersOrKickMe = (players) => {
        const $oldPlayerList = $(".js-player-item");
        const htmlTemplate = $("#tpl-user-item").html();

        const htmlPlayers = players.reduce((result, rawPlayer) => {
            const { siteURL, game, user } = CONFIG;
            const player = {
                ...rawPlayer,
                avatarURL: `${siteURL}${rawPlayer.avatarURL}`,
                is_leader: game.is_leader && user.id == rawPlayer.userId,
                isOffline: !rawPlayer.isOnline,
            };

            return rawPlayer.userId
                ? `${result}${compile(htmlTemplate, player)}`
                : result;
        }, "");

        $(elms.playerList).html(htmlPlayers);

        //check for kicked players
        const isCurrentPlayerExist =
            players.filter((p) => p.userId === CONFIG.user.id).length > 0
                ? true
                : false;

        const $snackbar = $(".snackbar");
        if (!isCurrentPlayerExist && !isLeaving && !kickedPopup) {
            kickedPopup = true;
            $snackbar
                .find(".snackbar__body")
                .html(
                    window.CFG?.strings.playerLeft.replace("{player}", "You"),
                );
            $snackbar.addClass("is-active");
            setTimeout(function () {
                window.location.reload();
            }, 3000);

            return false;
        }

        $oldPlayerList.each(function () {
            const $this = $(this);
            const playerId = parseInt($this.attr("player-id")) || 0;
            const playerName = $this.find(".gamePlayer__name").text();
            if (
                playerId &&
                CONFIG.user.id !== playerId &&
                !players.find((p) => p.userId === playerId)
            ) {
                $snackbar
                    .find(".snackbar__body")
                    .html(
                        window.CFG?.strings.playerLeft.replace(
                            "{player}",
                            playerName,
                        ),
                    );
                $snackbar.addClass("is-active");
                setTimeout(function () {
                    $snackbar.removeClass("is-active");
                }, 3000);
                return false;
            }
        });
    };

    const maybeReadyToStart = (players, isPlayingOnline = true) => {
        let allReady = false;
        if (Array.isArray(players)) {
            let validPlayers = 0;
            let readyPlayers = 0;

            players.forEach((player) => {
                if (player.ready) readyPlayers++;
                if (player.userId) validPlayers++;
            });

            if (players.length > 1) {
                allReady = readyPlayers > 1 && readyPlayers == validPlayers;
            }

            if (CONFIG.game.game_prop.singlePlayer && readyPlayers > 0) {
                allReady = true;
            }

            if (players.length === 1 && readyPlayers > 0 && isTestMode()) {
                allReady = true;
            }

            if (players.length === 1 && readyPlayers > 0 && !isPlayingOnline) {
                allReady = true;
            }
        }

        onReadyToStartStateChange(allReady);
    };

    const onReadyToStartStateChange = (isReady) => {
        $(elms.waitingroomSubtitle).toggleClass("hide", isReady);

        if (isReady) {
            $(elms.everyoneReady).show();
            $(elms.waitingEveryone).hide();
        } else {
            $(elms.everyoneReady).hide();
            $(elms.waitingEveryone).show();
        }

        if ($(elms.pageWaitingRoom).hasClass("is-leader")) {
            $(elms.proceedGame).prop("disabled", !isReady);

            $(elms.pageWaitingRoom).toggleClass(
                "is-all-players-ready",
                isReady,
            );
        }
    };

    const onPlayersStateChanged = (e, eData) => {
        /* Update players DOM */
        const players = eData?.data;
        updatePlayersOrKickMe(players);
        maybeReadyToStart(players, getState().pageWaitingRoom.isPlayingOnline);
    };

    bdjs.listen("bd__playersStateChanged", onPlayersStateChanged);

    const maybeGoToSetTeamname = (teamData) => {
        const isSetTeamname = teamData?.isSetTeamname;

        if (isSetTeamname) {
            $(elms.waitingroom).addClass("is-hidden");
            openTeamNameWrapper();
        } else {
            $(elms.waitingroom).removeClass("is-hidden");
            $(elms.setupTeamName).removeClass("is-open");
        }
    };

    const openTeamNameWrapper = () => {
        const $teamName = $(elms.teamName);
        const $firstWord = $(elms.firstWordTxt).find("p");
        const $startBtn1 = $teamName.siblings(".js-start-game");
        const $startBtn2 = $(".setupteamname__result-buttons").find(
            ".js-start-game",
        );
        if (!$teamName.val()) {
            $startBtn1.attr("disabled", "disabled");
            $startBtn1.addClass("disabled");
        } else {
            $startBtn1.removeAttr("disabled");
            $startBtn1.removeClass("disabled");
        }

        if ($firstWord.text().trim().toLowerCase() === "first") {
            $startBtn2.attr("disabled", "disabled");
            $startBtn2.addClass("disabled");
        } else {
            $startBtn2.removeAttr("disabled");
            $startBtn2.removeClass("disabled");
        }

        $(elms.setupTeamName).addClass("is-open");
    };

    const redirectTeamNamePage = () => {
        const region = getState().pageWaitingRoom.region;
        if (!region || region === "") {
            showSnackbarMessage(window.CFG?.strings.selectRegion);
            return;
        }

        fb.update(fb.teamAttributesPath, {
            isSetTeamname: true,
        });
    };

    const showSnackbarMessage = (text) => {
        const $snackbar = $(".snackbar");
        $snackbar.find(".snackbar__body").html(text);
        $snackbar.addClass("is-active");
        setTimeout(function () {
            $snackbar.removeClass("is-active");
        }, 3000);
    };

    // On Team Data Changed
    // ------------------------------------------------------------------------
    const maybeTeamNameChanged = (teamData) => {
        if ($(elms.pageWaitingRoom).hasClass("is-leader")) return;

        const isRandomTeamname = teamData?.isTeamnameRandom;
        const teamName = teamData?.teamname;
        teamNameTemp = teamName;

        if (isRandomTeamname) {
            const teamNameArr = teamName.split(" ");
            const categories = teamData?.randomCategories;
            const $firstRandomTeamname = $(elms.firstWordTxt);
            const $secondRandomTeamname = $(elms.secondWordTxt);

            $firstRandomTeamname.html(teamNameArr[0]);
            $secondRandomTeamname.html(teamNameArr[1]);

            $(elms.categoryBtn).removeClass("is-active");

            $.each(categories, function (index, item) {
                const $catButton = $(`${elms.categoryBtn}[data-id="${item}"]`);
                toggleActive($catButton);
            });
        } else {
            $(elms.teamName).val(teamName);
        }
    };

    const maybeTeamLeaderChanged = (teamData) => {
        const leaderId = teamData?.leader;

        if (!leaderId) return;

        const $elLeader = $(
            elms.playerItem.concat(`[player-id="${leaderId}"]`),
        );
        const leaderText = $(elms.playerList).attr("data-leader-text");
        const htmlLeader = `<div class="gamePlayer__teamLeader">${leaderText}</div>`;

        $elLeader.find(".js-leader-text").html(htmlLeader);

        if (leaderId == CONFIG.user.id /* && !CONFIG.game.is_leader */) {
            CONFIG.game.is_leader = true;
            // $(elms.leaderPopup).addClass("is-open");
            $(elms.pageWaitingRoom)
                .removeClass("is-member")
                .addClass("is-leader");
            $(elms.teamName).removeAttr("readonly");
            $elLeader.find(elms.deletePlayerBtn).addClass("hidden");
            $(elms.regionSelector).removeClass("is-disabled");
            $(elms.teamName).removeAttr("disabled");
            $(elms.startBtn).removeAttr("disabled");
            $(elms.categoryList).removeAttr("disabled");
            $(elms.randomizerBtn).removeAttr("disabled");
        }
    };

    /* start the game after video intro */
    const startTheGame = async () => {
        bdjs.showLoading();

        const startGameProps = {
            team_name: teamNameTemp,
            is_playing_online: isPlayingOnlineTemp,
            region: regionTemp,
        };
        await bdjs.goAsync(bdapi.post("game/start-game", startGameProps));

        setTimeout(() => {
            document.location.href = CONFIG.mainRoom;
        }, GameLogic.transisitonDuration);
    };

    /* skip the video intro */
    const skipIntroVideo = () => {
        const introVideo = videojs("intro-video");
        if (!introVideo.paused()) introVideo.pause();

        setHasSeenGameIntro();
        startTheGame();
    };

    let alreadyStarted = false;
    const maybeStartTheGame = (teamData) => {
        if (!teamData?.isStarting || alreadyStarted) return;

        let countdownInterval;
        let isVideoError = false;

        alreadyStarted = true;

        const startTheGame = async () => {
            bdjs.showLoading();

            const startGameProps = {
                team_name: teamNameTemp,
                is_playing_online: isPlayingOnlineTemp,
                region: regionTemp,
            };

            await bdjs.goAsync(bdapi.post("game/start-game", startGameProps));

            setTimeout(() => {
                document.location.href = CONFIG.mainRoom;
            }, GameLogic.transisitonDuration);
        };

        const videoUrl = $(".video-js").attr("data-video");
        const introVideo = videojs("intro-video", {
            controls: true,
            autoplay: true,
            preload: "auto",
            sources: [
                {
                    src: videoUrl,
                    type: "video/mp4",
                },
            ],
            techOrder: ["html5"],
        });

        introVideo.on("ended", function () {
            //go to main room on video ended
            setHasSeenGameIntro();
            startTheGame();
        });

        introVideo.on("error", function () {
            isVideoError = true;
        });

        const stopInterval = () => {
            clearInterval(countdownInterval);

            if (isVideoError) {
                //go to main room directly when intro video has error
                setHasSeenGameIntro();
                startTheGame();
                return;
            }

            $(elms.pageWaitingRoom).addClass("is-playing-intro");

            try {
                introVideo.play().catch((error) => {
                    // Autoplay was blocked. Do something
                    console.error("Unable to start auto play", error);
                });
            } catch (error) {
                console.error(error);
            }
        };

        stopInterval();
    };

    let countDownCounter = 0;
    const onTeamStateChanged = (e, eData) => {
        const teamData = eData?.data;

        // maybeIsPlayingOnline(teamData);
        // maybeUpdateRegion(teamData);

        maybeStartTheGame(teamData);

        if (countDownCounter === 0) {
            maybeGoToSetTeamname(teamData);
            maybeTeamNameChanged(teamData);
            maybeTeamLeaderChanged(teamData);
        }

        if (
            teamData.isCountDownStarting &&
            !teamData.isStarting &&
            countDownCounter === 0
        ) {
            countDownCounter += 1;
            onCountDownStarting();
        }

        if (teamData.region) {
            dispatch(setRegion(teamData.region));
            updateRegionFromFirebase(teamData.region);
        }

        const isPlayingOnline =
            teamData.isPlayingOnline === null ||
            typeof teamData.isPlayingOnline === "undefined"
                ? true
                : teamData.isPlayingOnline;
        dispatch(setPlayingOnline(isPlayingOnline));
        maybeReadyToStart(getState().gameProgress.players, isPlayingOnline);
    };

    bdjs.listen("bd__teamAttributeChanged", onTeamStateChanged);

    // Setup Team state on first load
    // ------------------------------------------------------------------------
    const setTeamInitialState = (e, eData) => {
        const teamData = eData?.data;
        const teamAttributes = teamData?.attributes;
        const isRandomTeamname = teamAttributes?.isTeamnameRandom || false;
        const teamname = teamAttributes?.teamname || "";
        const region = teamAttributes?.region || "";
        const isPlayingOnline =
            !teamAttributes ||
            teamAttributes?.isPlayingOnline === null ||
            typeof teamAttributes.isPlayingOnline === "undefined"
                ? true
                : teamAttributes.isPlayingOnline;
        $(".js-is-playing-online-text").text(
            isPlayingOnline
                ? window.CFG?.strings.virtual
                : window.CFG?.strings.physical,
        );
        dispatch(setPlayingOnline(isPlayingOnline));

        // set region
        $(elms.regionDropdown).val(region);

        // set is playing online
        $(elms.isPlayingOnlineToggle).prop("checked", isPlayingOnline);

        // set teamname
        if (isRandomTeamname) {
            const teamNameArr = teamname.split(" ");
            const categories = teamAttributes?.randomCategories;
            const $firstRandomTeamname = $(elms.firstWordTxt);
            const $secondRandomTeamname = $(elms.secondWordTxt);

            $firstRandomTeamname
                .html("<p>" + teamNameArr[0] + "</p>")
                .attr("data-id", categories[0]);
            $firstRandomTeamname.parent().removeClass("is-empty");
            $firstRandomTeamname.parent().find(".js-remove-word").show();

            $secondRandomTeamname
                .html("<p>" + teamNameArr[1] + "</p>")
                .attr("data-id", categories[1]);
            $secondRandomTeamname.parent().removeClass("is-empty");
            $secondRandomTeamname.parent().find(".js-remove-word").show();

            $.each(categories, function (index, item) {
                const $catButton = $(`${elms.categoryBtn}[data-id="${item}"]`);
                toggleActive($catButton);
            });
        } else {
            $(elms.teamName).val(teamname);
        }
    };

    bdjs.listen("bd__teamInitialState", setTeamInitialState);

    // Copy team id
    // ------------------------------------------------------------------------
    const onCopyTeamId = () => {
        const teamID = String($(elms.teamIdValue).val());
        const isCopied = copyTextToClipboard(teamID);
        if (!isCopied) return false;

        $(elms.teamId).addClass("is-copied");
        setTimeout(() => $(elms.teamId).removeClass("is-copied"), 1000);
    };

    // set region
    // ------------------------------------------------------------------------
    const updateRegion = () => {
        const regionVal = $(elms.regionDropdown).val();
        regionTemp = regionVal.toString();

        fb.update(fb.teamAttributesPath, {
            region: regionVal,
        });
    };

    const updateSelectedRegion = ($el) => {
        const regionvalue = $($el.target).data("region");

        regionTemp = regionvalue.toString();
        fb.update(fb.teamAttributesPath, {
            region: regionvalue,
        });
    };

    const updateRegionFromFirebase = (region) => {
        $(".js-region-button").removeClass("is-selected");
        $('.js-region-button[data-region="' + region + '"]').addClass(
            "is-selected",
        );
        $(elms.regionSelector).removeClass("is-active");
        $(elms.regionToggler).text(region);
    };

    const onregionToggle = () => {
        const $toggler = $(elms.regionSelector);
        const isOpen = $toggler.hasClass("is-active");

        $toggler.toggleClass("is-active", !isOpen);
    };

    // set is playing online
    // ------------------------------------------------------------------------
    const updateIsPlayingOnline = () => {
        const $isPlayingOnline = $(elms.isPlayingOnlineToggle);
        const isChecked = $isPlayingOnline.is(":checked");
        $(".js-is-playing-online-text").text(
            isChecked
                ? window.CFG?.strings.virtual
                : window.CFG?.strings.physical,
        );

        isPlayingOnlineTemp = isChecked ? 1 : 0;
        fb.update(fb.teamAttributesPath, {
            isPlayingOnline: isChecked,
        });
    };

    // set team name on input
    // ------------------------------------------------------------------------

    const updateFbTeamname = (teamName, isRandom, randomCategory = []) => {
        teamNameTemp = String(teamName).trim();
        fb.update(fb.teamAttributesPath, {
            teamname: String(teamName).trim(),
            isTeamnameRandom: isRandom,
            randomCategories: randomCategory,
        });
    };

    let timeToWait = 2; //seconds

    /**
     * @type {ReturnType<typeof setInterval> | undefined}
     */
    let intervalUpdate = undefined;

    $(document).on("input", elms.teamName, function () {
        const value = $(this).val();

        clearInterval(intervalUpdate);
        timeToWait = 2;
        intervalUpdate = setInterval(() => {
            timeToWait--;

            if (timeToWait <= 0) {
                clearInterval(intervalUpdate);

                updateFbTeamname(String(value).trim(), false);
            }
        }, 1000);
    });

    // Kick player
    const onKickMember = async (e) => {
        e.preventDefault();

        const $btn = $(e.currentTarget);
        const isLoading = $btn.hasClass("is-loading");
        if (isLoading) return false;

        const $playerToDelete = $btn.parents(elms.playerItem);
        const memberID = $playerToDelete.attr("player-id");
        if ($btn.hasClass("is-loading")) return;

        $btn.addClass("is-loading");

        await bdjs.goAsync(
            bdapi.post("member/kick-member", { member_id: memberID }),
        );

        $btn.removeClass("is-loading");
    };

    // Onboarding Box
    // ------------------------------------------------------------------------
    // let isLoading = false;
    const onToggleReady = () => {
        const region = getState().pageWaitingRoom.region;
        if (CONFIG.game.is_leader && !isReady && (!region || region === "")) {
            showSnackbarMessage(window.CFG?.strings.selectRegion);
            return;
        }

        fb.update(fb.currentPlayerPath, {
            ready: !isReady,
        });
    };

    // Countdown button start the game
    // ------------------------------------------------------------------------
    $(document).on("click", elms.startBtn, (e) => {
        e.preventDefault();

        // updateTeamAttribute();
        const $teamName = $(elms.teamName);
        const $firstWord = $(elms.firstWordTxt).find("p");
        if (
            !$teamName.val() &&
            $firstWord.text().trim().toLowerCase() === "first"
        ) {
            showSnackbarMessage(window.CFG?.strings.chooseTeamName);
            return;
        }

        fb.update(fb.teamAttributesPath, { isCountDownStarting: true });
    });

    const onCountDownStarting = () => {
        $(elms.pageWaitingRoom).addClass("is-countdown");
        $(".setupteamname").removeClass("is-open").addClass("is-hidden");

        const startCOuntdown = function () {
            const count = parseInt($("#countSecond").text());
            if (count > 0) {
                $("#countSecond").html(String(count - 1));
            } else {
                if ($(elms.pageWaitingRoom).hasClass("is-leader")) {
                    fb.update(fb.teamAttributesPath, { isStarting: true });
                }
            }
        };

        setInterval(startCOuntdown, 1000);
    };

    // Leave Game
    // ------------------------------------------------------------------------
    const onLeaveTeam = async (e) => {
        e.preventDefault();

        if (isLoading) return false;
        const confirm_result = confirm(window.CFG?.strings.confirmLeave);

        if (!confirm_result) {
            return false;
        }

        const $this = $(e.currentTarget);

        $this.addClass("is-loading");
        isLoading = true;
        isLeaving = true;

        await bdjs.goAsync(bdapi.post("member/leave-team"));
        window.location.reload();
        return false;
    };

    // Leader Popup
    // ------------------------------------------------------------------------

    const closeLeaderPopup = function (e) {
        e.preventDefault();
        const $this = $(this);
        $this.parents(elms.leaderPopup).removeClass("is-open");
    };

    $(elms.leaderPopup)
        .find(".js-completionPopup-close")
        .on("click", closeLeaderPopup);

    // Team name generator
    // ------------------------------------------------------------------------

    /**
     * toggle disabled state of element
     */
    const toggleDisableElement = ($el, is_disabled) => {
        $el.toggleClass("disabled", is_disabled);
        $el.prop("disabled", is_disabled);
    };

    const wordCount = () => {
        const words_count = 0;

        return words_count;
    };

    /**
     * set active state on category button
     */
    const toggleActive = ($el) => {
        if (!$el.hasClass("is-active")) {
            if (wordCount() < 2) {
                $el.addClass("is-active");
            }
        }
    };

    /**
     * handle random words
     * @param {string} category_id
     */
    const randomWord = (category_id) => {
        const randomizer = CONFIG.game.randomizer;
        let words = [];

        $.each(randomizer, function (index, item) {
            if (item.category_id == category_id) {
                words = item.words;
            }
        });

        const random_word = words[Math.floor(Math.random() * words.length)];

        if (typeof random_word != "undefined") {
            return random_word.word;
        }
    };

    /**
     * Handle on click category button
     * @param {*} e
     */
    const onClickCategory = (e) => {
        e.preventDefault();

        const $this = $(e.target);
        const $inputTeamName = $(elms.teamName);
        $inputTeamName.hide();

        const id = $this.attr("data-id");
        const random_word = randomWord(id);
        const $startBtn = $(elms.startBtn);
        const first_word = $(elms.firstWordTxt);
        const second_word = $(elms.secondWordTxt);

        // set first word
        if (first_word.attr("data-id") === "") {
            first_word.html("<p>" + random_word + "</p>");
            first_word.attr("data-id", id);
            first_word.parent().find(elms.removeBtn).show();
            first_word.parent().removeClass("is-empty");

            if (wordCount() == 2) {
                toggleDisableElement($(elms.categoryBtn), true);
                toggleDisableElement($(elms.randomizerBtn), true);
                toggleDisableElement($this, false);
            }
        }

        // handle multiple clicking on first category
        if (
            first_word.attr("data-id") === id &&
            first_word.attr("data-id") !== ""
        ) {
            first_word.html("<p>" + random_word + "</p>");
            toggleActive($this);
            first_word.parent().find(elms.removeBtn).show();
            first_word.parent().removeClass("is-empty");
        }

        // set second word
        if (
            first_word.attr("data-id") != "" &&
            id != first_word.attr("data-id") &&
            second_word.attr("data-id") == ""
        ) {
            second_word.html("<p>" + random_word + "</p>");
            second_word.attr("data-id", id);
            second_word.parent().find(elms.removeBtn).show();
            second_word.parent().removeClass("is-empty");

            if (wordCount() == 2) {
                toggleDisableElement($(elms.categoryBtn), true);
                toggleDisableElement($(elms.randomizerBtn), true);
                toggleDisableElement($this, false);
            }
        }

        // handle multiple clicking on second category
        if (
            second_word.attr("data-id") === id &&
            second_word.attr("data-id") !== ""
        ) {
            second_word.html("<p>" + random_word + "</p>");
            toggleActive($this);
            second_word.parent().find(elms.removeBtn).show();
            second_word.parent().removeClass("is-empty");
        }

        //if words count already 2, then enable save button
        if (first_word.html() != "" && first_word.html() != "") {
            toggleDisableElement($startBtn, false);
        }

        let fullTeamName;
        let categories = [];

        if (first_word.attr("data-id") !== "") {
            fullTeamName = first_word.text();
            categories.push(first_word.attr("data-id"));
        }

        if (second_word.attr("data-id") !== "") {
            fullTeamName = `${first_word.text()} ${second_word.text()}`;
            categories = [
                first_word.attr("data-id"),
                second_word.attr("data-id"),
            ];
        }

        updateFbTeamname(fullTeamName, true, categories);
    };

    const onClickRandomizer = (e) => {
        e.preventDefault();

        const $this = $(this);
        const $startBtn = $(elms.startBtn);

        toggleActive($this);
        $(elms.teamName).hide();

        const randomizer = CONFIG.game.randomizer;
        const category_ids = [];

        $.each(randomizer, function (index, item) {
            category_ids.push(item.category_id);
        });

        const random_first_index =
            category_ids[Math.floor(Math.random() * category_ids.length)];
        const random_second_index =
            category_ids[Math.floor(Math.random() * category_ids.length)];

        const first_word = $(".first-word");
        const second_word = $(".second-word");

        const random_first_word = randomWord(random_first_index);
        const random_second_word = randomWord(random_second_index);

        first_word.html("<p>" + random_first_word + "</p>");
        first_word.attr("data-id", random_first_index);
        first_word.parent().find(elms.removeBtn).show();
        first_word.parent().removeClass("is-empty");

        second_word.html("<p>" + random_second_word + "</p>");
        second_word.attr("data-id", random_second_index);
        second_word.parent().find(elms.removeBtn).show();
        second_word.parent().removeClass("is-empty");

        toggleDisableElement($startBtn, false);
        toggleDisableElement($(elms.categoryBtn), true);

        const fullTeamName = `${first_word.text()} ${second_word.text()}`;
        const categories = [
            first_word.attr("data-id"),
            second_word.attr("data-id"),
        ];

        updateFbTeamname(fullTeamName, true, categories);

        $(elms.categoryBtn).removeClass("is-active");
    };

    const isTeamNameFilled = () => {
        const teamnameVal = $(elms.teamName).val();
        const $startBtn = $(elms.startBtn);
        const $categoryBtn = $(elms.categoryBtn);
        const $randomizerBtn = $(elms.randomizerBtn);

        if (teamnameVal) {
            toggleDisableElement($startBtn, false);
            toggleDisableElement($categoryBtn, true);
            toggleDisableElement($randomizerBtn, true);
        } else {
            toggleDisableElement($startBtn, true);
            toggleDisableElement($categoryBtn, false);
            toggleDisableElement($randomizerBtn, false);
        }
    };

    const onCancelStart = () => {
        onToggleReady();
    };

    $(document).on("click", elms.skipVideoBtn, skipIntroVideo);
    $(document).on("click", elms.teamIdCopy, onCopyTeamId);
    $(document).on("click", elms.deletePlayerBtn, onKickMember);
    $(document).on("click", elms.readyBtn, onToggleReady);
    $(document).on("click", elms.cancelBtn, onToggleReady);
    $(document).on("click", elms.cancelStart, onCancelStart);
    $(document).on("click", elms.gameInfoLeave, onLeaveTeam);
    $(document).on("click", elms.categoryList, onClickCategory);
    $(document).on("click", elms.randomizerBtn, onClickRandomizer);
    $(document).on("input", elms.teamName, isTeamNameFilled);
    $(document).on("change", elms.regionDropdown, updateRegion);
    $(document).on("click", elms.regionToggler, onregionToggle);
    $(document).on("click", elms.regionSelectorButton, updateSelectedRegion);
    $(document).on("change", elms.isPlayingOnlineToggle, updateIsPlayingOnline);
    $(document).on("click", elms.proceedGame, redirectTeamNamePage);
    $(document).on("click", elms.removeBtn, function () {
        const $this = $(this);
        const $word = $this.prev();
        const placeholder = $word.data("pos");
        const id = $word.attr("data-id");
        const $startBtn = $(elms.startBtn);

        $(elms.categoryList).find(`[data-id="${id}"]`).removeClass("is-active");
        $word.attr("data-id", "").find("p").text(placeholder);
        $word.parent().addClass("is-empty");

        $this.hide();

        if (wordCount() == 0) {
            $(elms.teamName).show();
            toggleDisableElement($startBtn, true);
        }

        if (wordCount() < 2) {
            $(elms.randomizerBtn).removeClass("is-active");
            toggleDisableElement($(elms.randomizerBtn), false);
            toggleDisableElement($(elms.categoryBtn), false);
        }
    });

    const $snackBar = $(".snackbar");
    $snackBar.find(".snackbar__close").on("click", function (e) {
        e.preventDefault();
        $snackBar.removeClass("is-active");
    });

    GameLogic.listenGameProgressChanged();
};
